<template>
  <main class="auth-page auth-page--customer">
    <div class="auth-orb auth-orb--a" aria-hidden="true" />
    <div class="auth-orb auth-orb--b" aria-hidden="true" />
    <div class="auth-grid" aria-hidden="true" />

    <section class="auth-shell">
      <aside class="auth-hero">
        <h1 class="auth-title">客户中心</h1>
        <p class="auth-lead">查看广告记录与设备状态，随时掌握投放表现。</p>
        <ul class="auth-points">
          <li>
            <el-icon><Tickets /></el-icon>
            <span>广告收益与记录一目了然</span>
          </li>
          <li>
            <el-icon><Coin /></el-icon>
            <span>收益占比可按需调整展示</span>
          </li>
          <li>
            <el-icon><Iphone /></el-icon>
            <span>设备与应用状态随时可查</span>
          </li>
        </ul>
      </aside>

      <div class="auth-form-wrap">
        <div class="auth-form-head">
          <h2>登录客户后台</h2>
          <p>请使用管理员开通的账号与密码登录</p>
        </div>

        <el-form ref="formRef" :model="form" :rules="rules" label-position="top" @keyup.enter="submit">
          <el-form-item label="账号" prop="phone">
            <el-input
              v-model.trim="form.phone"
              size="large"
              placeholder="请输入账号"
              :prefix-icon="Iphone"
              clearable
            />
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              size="large"
              show-password
              placeholder="请输入密码"
              :prefix-icon="Lock"
            />
          </el-form-item>
          <el-button type="primary" size="large" :loading="loading" class="auth-submit" @click="submit">
            进入客户后台
          </el-button>
        </el-form>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed, inject, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Coin, Iphone, Lock, Tickets } from '@element-plus/icons-vue'

const customer = inject('customer')
const router = useRouter()
const loading = computed(() => customer.loading.value)

const formRef = ref()
const form = reactive({ phone: '', password: '' })
const rules = {
  phone: [
    { required: true, message: '请输入客户账号', trigger: 'blur' }
  ],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
}

const submit = async () => {
  if (!(await formRef.value.validate().catch(() => false))) return
  await customer.login({ phone: form.phone, password: form.password })
  if (customer.token.value) router.push('/customer')
}
</script>
